import { useEffect } from "react";
import CloseIcon from "../../assets/icons/CloseIcon";
import styles from "./style.module.css";

interface CustomModalProps {
  children: React.ReactNode;
  show: boolean;
  modalTitle: string;
  onClickClose: () => void;
}
const CustomModal: React.FC<Partial<CustomModalProps>> = ({
  children,
  show,
  modalTitle,
  onClickClose,
}) => {
  useEffect(() => {
    const appBody = document.querySelector("body");
    if (appBody) {
      appBody.style.overflow = show ? "hidden" : "auto";
    }

    return () => {
      if (appBody) {
        appBody.style.overflow = "auto";
      }
    };
  }, [show]);
  return (
    <>
      {show && (
        <div className={styles.overlay}>
          <div className={`${styles.modal} ${styles.customModal}`}>
            <div className={styles.modalHeader}>
              {modalTitle && <h4>{modalTitle}</h4>}
              {onClickClose && (
                <button onClick={onClickClose}>
                  <CloseIcon />
                </button>
              )}
            </div>
            <div className={styles.modalChild}>{children}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomModal;
